import { render, staticRenderFns } from "./productStatistics.vue?vue&type=template&id=18306a8c&scoped=true&"
import script from "./productStatistics.vue?vue&type=script&lang=js&"
export * from "./productStatistics.vue?vue&type=script&lang=js&"
import style0 from "./productStatistics.vue?vue&type=style&index=0&id=18306a8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18306a8c",
  null
  
)

export default component.exports